export enum ReportStatusEnum {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Inspected = 'inspected',
  CannotInspect = 'cannot_inspect',
  NotPresent = 'not_present',
  Fixed = 'fixed',
  Issue = 'issue',
}

export enum ReportItemEnum {
  System = 'ReportSystem',
  Subsystem = 'ReportSubsystem',
  ApplianceInformation = 'ReportApplianceInformation',
  Information = 'ReportInformation',
  Deficiency = 'ReportDeficiency',
  Limitation = 'ReportLimitation',
  Attachment = 'ReportAttachment',
}

export enum ReportSeverity {
  Monitor = 'monitor',
  Repair = 'repair',
  Safety = 'safety',
  InspectifyFlag = 'inspectify_flag',
}

export enum ReportApplianceStatus {
  PendingData = 'pending_data',
  Source7Ready = 'source7_ready',
  Source7Retrieved = 'source7_retrieved',
  Source7Verified = 'source7_verified',
  InspectorSkipped = 'inspector_skipped',
  InspectorVerified = 'inspector_verified',
  InspectifyFixed = 'inspectify_fixed',
}

export enum ReInspectionStatus {
  Fixed = 'fixed',
  StillExists = 'still_exists',
}

export enum DeficiencyRecommendation {
  Evaluation = 'evaluation',
  RepairReplace = 'repair_or_replace',
  Monitor = 'monitor',
}

export enum ReportOrientation {
  Any = 'any_orientation',
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export enum ReportMedia {
  Any = 'any_media_type',
  Video = 'video',
  Photo = 'photo',
  PhotoSphere = 'photo_sphere',
  Document = 'document',
  Pdf = 'pdf',
}

export enum ReportDeliveryFilter {
  FullReport = 'Full report',
  FixedDefectsOnly = 'Fixed issues only',
  RemainingDefectsOnly = 'Remaining issues only',
  IssuesOnly = 'Issues only',
  MediaOnly = 'Media only',
  AppliancesOnly = 'Appliances only',
}

export const enum ReportFilterEnum {
  FullReport = 'Full Report',
  IssuesOnly = 'Issues only',
  MediaOnly = 'Media only',
  AppliancesOnly = 'Appliances only',
}
